function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Details");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Book/-Card---1820",
  transform: "translate(-371.000000, -18.000000)"
}, React.createElement("g", {
  id: "Icons/Details",
  transform: "translate(365.000000, 16.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "Background"
}), React.createElement("path", {
  d: "M8,5 C7.17157288,5 6.5,4.32842712 6.5,3.5 C6.5,2.67157288 7.17157288,2 8,2 C8.82842712,2 9.5,2.67157288 9.5,3.5 C9.5,4.32842712 8.82842712,5 8,5 Z M8,14 C7.17157288,14 6.5,13.3284271 6.5,12.5 C6.5,11.6715729 7.17157288,11 8,11 C8.82842712,11 9.5,11.6715729 9.5,12.5 C9.5,13.3284271 8.82842712,14 8,14 Z",
  id: "Combined-Shape",
  fill: "#1E1F20",
  fillRule: "evenodd",
  mask: "url(#mask-2)",
  transform: "translate(8.000000, 8.000000) rotate(-180.000000) translate(-8.000000, -8.000000) "
}))));

var SvgDetails = function SvgDetails(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "4px",
    height: "12px",
    viewBox: "0 0 4 12",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDetails, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/details.0be75850.svg";
export { ForwardRef as ReactComponent };